import { lazy } from 'react';
// 分销商列表
const DistributorList = lazy(() => import('pages/distributorList'));
// 分销商详情
const DistributorDetail = lazy(() => import('pages/distributorDetail'));
const DistributorAudit = lazy(() => import('pages/distributorAudit'));
// 分销商列表
// const DistributorClueList = lazy(() => import('pages/distributorClueList'));

export const router = {
    path: '/distributor',
    name: '分销商管理',
    icon: 'exception',
    permission: 102,
    children: [
        {
            path: 'distributorList',
            name: '分销商列表',
            icon: 'profile',
            permission: 10201,
            component: DistributorList,
        },
        {
            path: 'distributorDetail',
            name: '分销商详情',
            icon: '_space',
            hideInMenu: true,
            permission: 10201,
            component: DistributorDetail,
        },
        {
            path: 'distributorAudit/:id/:pid',
            name: '分销商审核',
            icon: '_space',
            hideInMenu: true,
            permission: 10201,
            component: DistributorAudit,
        },
        // {
        //     path: 'distributorClueList',
        //     name: '分销商线索列表',
        //     icon: 'profile',
        //     permission: 102,
        //     component: DistributorClueList,
        // },
    ],
};

export default router;
